import { render, staticRenderFns } from "./highlighter-popup.vue?vue&type=template&id=272a774c&"
import script from "./highlighter-popup.vue?vue&type=script&lang=js&"
export * from "./highlighter-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports